import React, { useContext, useEffect } from 'react';
import {
    Card,
    CardActionArea,
    CardMedia,
    Typography,
    Box,
    //Chip,
    Button,
} from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import axios from 'axios';
// import Config from '../config/Config.js';
import RestauLocationMappingDialog from './RestauLocationMappingDialog.js';
import axios from 'axios';
import Config from '../config/Config.js';
import { RestauInfoContext } from '../home/RestauInfoContext.js';

export default function SquareIntegration({
    onIntegrationComplete,
    existingRestauPosMapping,
    restauIdsWithAccess,
}) {
    const [squareLocations, setSquareLocations] = React.useState([]);
    const [showMappingDialog, setShowMappingDialog] = React.useState(false);
    const [integrationLoading, setIntegrationLoading] = React.useState(false);
    const [merchantId, setMerchantId] = React.useState(null);

    const resauInfoContext = useContext(RestauInfoContext);
    const restauHook = resauInfoContext.restauHook;

    // Check for OAuth callback on component mount
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');

        if ((code || error) && window.opener && window.opener !== window) {
            const storedState = sessionStorage.getItem('square_oauth_state');

            if (error) {
                window.opener.postMessage(
                    {
                        type: 'square_oauth_callback',
                        success: false,
                        error: urlParams.get('error_description') || error,
                    },
                    '*'
                );
            } else if (state === storedState && code) {
                window.opener.postMessage(
                    {
                        type: 'square_oauth_callback',
                        success: true,
                        code: code,
                    },
                    '*'
                );
            }

            document.body.innerHTML = `
                <div style="display: flex; align-items: center; justify-content: center; height: 100vh; font-family: Arial;">
                    <div style="text-align: center; padding: 20px;">
                        <h2 style="color: ${error ? '#d32f2f' : '#2e7d32'};">
                            ${
                                error
                                    ? '❌ Authorization Failed'
                                    : '✅ Authorization Successful'
                            }
                        </h2>
                        <p>This window will close automatically...</p>
                    </div>
                </div>
            `;

            setTimeout(() => window.close(), 1500);
            return;
        }
    }, []);

    const generateStateToken = () => {
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);
        return Array.from(array, (byte) =>
            byte.toString(16).padStart(2, '0')
        ).join('');
    };

    const initiateSquareOAuth = () => {
        const stateToken = generateStateToken();
        sessionStorage.setItem('square_oauth_state', stateToken);

        const clientId = 'sandbox-sq0idb-BGV1U4aD4be-ZB4t9JB_RQ';
        const redirectUri = encodeURIComponent(window.location.origin + '/pos');
        const scope = encodeURIComponent(
            'ORDERS_WRITE PAYMENTS_WRITE MERCHANT_PROFILE_READ'
        );

        const oauthUrl =
            `https://connect.squareupsandbox.com/oauth2/authorize?` +
            `client_id=${clientId}&response_type=code&scope=${scope}&redirect_uri=${redirectUri}&state=${stateToken}`;

        const width = 600,
            height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        const popup = window.open(
            oauthUrl,
            'Square OAuth',
            `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`
        );

        if (!popup || popup.closed) {
            alert(
                'Please allow popups for this site to complete Square integration.'
            );
            return;
        }

        const handleMessage = async (event) => {
            //debugger;
            if (event.data && event.data.type === 'square_oauth_callback') {
                console.log('Received OAuth callback:', event.data);

                //cleanup
                window.removeEventListener('message', handleMessage);

                if (event.data.success && event.data.code) {
                    try {
                        setIntegrationLoading(true);

                        // Call backend to exchange code for token and get locations
                        const response = await axios.post(
                            Config.completeSquareIntegration,
                            {
                                code: event.data.code,
                                restauId: restauHook.restauId,
                            },
                            {
                                headers: {
                                    token: await window.customerApp
                                        .auth()
                                        .currentUser.getIdToken(),
                                },
                            }
                        );

                        setIntegrationLoading(false);

                        console.log('response: ', response);

                        if (response.data.success) {
                            // Store locations and show selection dialog
                            if (response.data.locations)
                                setSquareLocations(response.data.locations);
                            setMerchantId(
                                response.data.merchantId ||
                                    'MERCHANT_SQUARE_123'
                            );

                            setIntegrationLoading(false);
                            setShowMappingDialog(true);
                        } else {
                            throw new Error(
                                'No locations returned from Square'
                            );
                        }

                        // Clear session storage
                        sessionStorage.removeItem('square_oauth_state');
                        sessionStorage.removeItem('square_oauth_restaurant');
                    } catch (error) {
                        setIntegrationLoading(false);
                        alert(
                            'Failed to complete integration: ' + error.message
                        );
                    }
                } else {
                    alert(
                        event.data.error ||
                            'Square integration was cancelled or failed.'
                    );
                }
            }
        };

        window.addEventListener('message', handleMessage);

        const checkInterval = setInterval(() => {
            if (popup.closed) {
                clearInterval(checkInterval);
                window.removeEventListener('message', handleMessage);
            }
        }, 1000);
    };

    const handleSaveMappings = async (changeData) => {
        const { allMappings, merchantId } = changeData;

        console.log('Saving new mappings:', allMappings);
        console.log('Merchant ID:', merchantId);

        // Call backend to save new mappings (no existing mappings to delete during initial setup)
        const response = await axios.post(
            Config.savePosSettings,
            {
                restauId: restauHook.restauId,
                posMerchantId: merchantId,
                // All new mappings for initial integration
                activeMappings: allMappings.reduce((acc, curr) => {
                    acc[curr.restauId.id] = curr.location.id;
                    return acc;
                }, {}),
                // No deleted mappings for initial integration
                deletedMappings: {},
            },
            {
                headers: {
                    token: await window.customerApp
                        .auth()
                        .currentUser.getIdToken(),
                },
            }
        );

        console.log('Save mappings response: ', response);

        if (
            response &&
            response.status === 200 &&
            response.data.status === 'success'
        ) {
            alert(`Successfully created ${allMappings.length} mapping(s)!`);
        } else {
            alert('Failed to save mappings. Please try again.');
        }

        setShowMappingDialog(false);

        if (onIntegrationComplete) {
            onIntegrationComplete();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: { xs: '100%', sm: 'auto' },
            }}
        >
            {/* Square POS Card */}
            <Card
                sx={{
                    width: { xs: '100%', sm: 140 },
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: '1px solid #e0e0e0',
                    '&:hover': { boxShadow: 3, transform: 'translateY(-2px)' },
                }}
                onClick={initiateSquareOAuth}
            >
                <CardActionArea>
                    <Box
                        sx={{
                            p: 1.5,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <CardMedia
                            component="img"
                            sx={{
                                width: 80,
                                height: 80,
                                objectFit: 'contain',
                                mb: 1,
                            }}
                            image="https://storage.googleapis.com/sliceq-takeout/Square-logo-square.webp"
                            alt="Square POS"
                        />
                        <Typography variant="body1">Square POS</Typography>
                    </Box>
                </CardActionArea>
            </Card>

            {/* Start Integration Button */}
            <Box sx={{ mt: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={initiateSquareOAuth}
                    disabled={integrationLoading}
                    fullWidth
                >
                    {integrationLoading ? 'Connecting...' : 'Connect Square'}
                </Button>
            </Box>

            {/* Mapping Dialog */}
            <RestauLocationMappingDialog
                open={showMappingDialog}
                onClose={() => setShowMappingDialog(false)}
                onSave={handleSaveMappings}
                posType="square"
                posLocations={squareLocations}
                restauIdsWithAccess={restauIdsWithAccess}
                existingRestauPosMappings={existingRestauPosMapping}
                merchantId={merchantId}
            />
        </Box>
    );
}
